import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTop = () => {
  const [scrollPercent, setScrollPercent] = useState(0);
  const [visible, setVisible] = useState(false);

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      const scrolled =
        window.scrollY / (document.body.scrollHeight - window.innerHeight);
      setScrollPercent(scrolled * 100);
      setVisible(window.scrollY > 200); // Show after 200px scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`scroll-top-btn ${visible ? "show" : ""}`}
      onClick={scrollToTop}
      title="Back to Top"
    >
      <svg className="progress-ring" viewBox="0 0 40 40">
        <circle
          className="progress-ring__circle"
          cx="20"
          cy="20"
          r="18"
          fill="transparent"
          stroke="#ff6b00"
          strokeWidth="3"
          strokeDasharray="113"
          strokeDashoffset={113 - (113 * scrollPercent) / 100}
        />
      </svg>
      <FaArrowUp className="up-icon" />
    </div>
  );
};

export default ScrollToTop;
